<mat-sidenav-container class="client-container">
  <mat-sidenav
    class="main row client_details"
    style="width: 50%"
    #sidenav
    mode="over"
    position="end"
    [opened]="openPropertyListingValue"
    disableClose
  >
    <div>
      <div class="sliding-sheet-header">
        <h4>Marketing Emails ({{ clientMarketingEmailDetails.insertedDate | date: 'MMM d' }})</h4>
        <button type="button" (click)="closeSheet()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="row px-4 py-2">
        <div class="col-sm-12 col-md-12 col-12">
          <h4 class="my-4">Property Listings ({{ propertyRecommended.length }})</h4>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-md-6 col-sm-6 col-12" *ngFor="let property of propertyRecommended">
          <app-property-card class="prop-card" [property]="property"></app-property-card>
        </div>
      </div>
      <mat-paginator (page)="pageChange($event)" [pageSizeOptions]="[10, 20]" showFirstLastButtons> </mat-paginator>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
